let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4GFes")).then(() => parcelRequire('3mJDw'));